import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';
import {
  DeleteTaskManagerSectionDocument,
  type DeleteTaskManagerSectionMutationVariables,
} from '@/graphql/generated/graphql';

export type DeleteTaskManagerSectionVariables = DeleteTaskManagerSectionMutationVariables;

export const useDeleteTaskManagerSection = () => {
  const mutation = useMutation({
    mutationKey: ['delete-task-manager-section'],
    mutationFn: (variables: DeleteTaskManagerSectionMutationVariables) =>
      graphqlClient.request(DeleteTaskManagerSectionDocument, variables),
  });

  return {
    ...mutation,
    deleteTaskManagerSection: mutation.mutate,
    deleteTaskManagerSectionAsync: mutation.mutateAsync,
  };
};

export const DELETE_TASK_MANAGER_SECTION_MUTATION = DeleteTaskManagerSectionDocument;
